import { batch } from "react-redux";
import { AnyAction } from "redux";
import { AppRouteApi } from "../../config/appRoute";
import { AxiosAuth } from "../../core/axios";
import { StorageAuth } from "../../core/localStorage";
import { ActionAuth, useAppDispatch } from "../../core/redux";
import { ApiResponseContainer } from "../../models/api";
import { ApiSchemaSuperUserProfile } from "../../models/api/superAdminProfile";

type FetchFunctions = {
  fetchProfile: () => Promise<boolean>;
};

export function useProfileFetchFunc(): FetchFunctions {
  const dispatch = useAppDispatch();

  const fetchProfile = async () => {
    let returnValue = false;
    try {
      const reduxActions: AnyAction[] = [];
      const actions: (() => unknown | void)[] = [];

      const profile = await AxiosAuth.get<
        ApiResponseContainer<ApiSchemaSuperUserProfile>
      >(AppRouteApi.Profile.SuperUser());
      let companyId = profile.data.data?.companySKey;
      let companyName = profile.data.data?.companyName;
      let firstName = profile.data.data?.firstName;
      let lastName = profile.data.data?.lastName;
      let profilePic = profile.data.data?.profilePic;
      if (profile.data.isSuccess) {
        StorageAuth.CompanyId = companyId;
        StorageAuth.CompanyName = companyName;
        StorageAuth.ProfilePic = profilePic;
        !!companyId && reduxActions.push(ActionAuth.SetCompanyId(companyId));
        !!companyName &&
          reduxActions.push(ActionAuth.SetCompanyName(companyName));
        !!firstName && reduxActions.push(ActionAuth.SetFirstName(firstName));
        !!lastName && reduxActions.push(ActionAuth.SetLastName(lastName));
        !!profilePic && reduxActions.push(ActionAuth.SetProfilePic(profilePic));
      }

      batch(() => reduxActions.forEach(dispatch));
      actions.forEach((func) => func());
      returnValue = true;
    } catch (e: any) {
      // todo: Handle error.
    }

    return returnValue;
  };

  return {
    fetchProfile,
  };
}
